import { Component, Input, OnInit, ViewEncapsulation, ViewChild, ElementRef, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-mp3-volume',
  templateUrl: './mp3-volume.component.html',
  styleUrls: ['./mp3-volume.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class Mp3VolumeComponent implements AfterViewInit {
  @Input()
  audio: HTMLAudioElement;
  @Input()
  currentSoundEffect: HTMLAudioElement;
  @Input()
  darkColor: boolean;

  @ViewChild('volume', {static: false})
  volumeInputRef: ElementRef;

  public shouldPush: boolean;

  ngAfterViewInit() {
    this.value = +localStorage.getItem('playerVolume') || 50;
    this.audio.volume = this.value / 100;
    if (this.currentSoundEffect) {
      this.currentSoundEffect.volume = this.value / 100;
    }
  }

  get value() {
    return this.volumeInputRef.nativeElement.value;
  }

  set value(value) {
    this.volumeInputRef.nativeElement.value = value;
  }

  changeVolume() {
    this.audio.volume = this.value / 100;
    if (this.currentSoundEffect) {
      this.currentSoundEffect.volume = this.value / 100;
    }
    localStorage.setItem('playerVolume', this.value.toString());
  }
}
